var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 354.36 84.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .skin {\n        fill: #dcba8b;\n      }\n      .cls-2 {\n        fill: #dadada;\n      }\n      .cls-3 {\n        fill: #002029;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "happy"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "skin",
    cx: 289.57,
    cy: 43.43,
    rx: 64.79,
    ry: 41.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 289.57,
    cy: 45.32,
    rx: 64.79,
    ry: 32
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "skin",
    cx: 64.79,
    cy: 41.43,
    rx: 64.79,
    ry: 41.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 64.79,
    cy: 45.32,
    rx: 64.79,
    ry: 32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.9,20.22A28.21,28.21,0,1,0,91.51,36.06,28.2,28.2,0,0,0,54.9,20.22Zm2.47,25.71-.75,7.71-6.09-4.79-7.71-.76L47.62,42l.75-7.71,6.09,4.79,7.71.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M277.15,20.59A28.21,28.21,0,1,0,314.58,34.4,28.21,28.21,0,0,0,277.15,20.59ZM282,45.06l-.33,7.75-6.34-4.46L267.58,48,272,41.68l.33-7.74,6.34,4.45,7.74.34Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset31);
export default __webpack_public_path__ + "static/media/Asset 31.e1d349c3.svg";
export { ForwardRef as ReactComponent };